<div class="header">
  <span>
    <img src="./assets/comcst-logo-v1.svg" class="logo" routerLink="/" style="cursor: pointer;" *ngIf="!disableLink">
    <img src="./assets/comcst-logo-v1.svg" class="logo" *ngIf="disableLink">
  </span>
  <div class="navbar-header" [ngClass]="{'header-font': env != 'prod'}" *ngIf="!disableLink">
    <a (click)="onClickSearchPS()">{{title}}</a>
  </div>
  <div class="navbar-header1" [ngClass]="{'header-font': env != 'prod'}" *ngIf="disableLink">
    <span *ngIf="disableLink">{{title}}</span>
  </div>
</div>
